import { ModulesMap } from '@/config/data/modulesMaps'
import WorksMaterialConsumptionRateNormsApi from '@/services/apiServiceModules/worksMaterialConsumptionRateNormsApi'
import DataTransferModule from '@/services/dataTransferModule'

const worksMaterialConsumptionRateNormsApi = new WorksMaterialConsumptionRateNormsApi()

export default class WorksMaterialConsumptionRateNormsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS, worksMaterialConsumptionRateNormsApi, {
			useCache: true
		})
	}
}